import useSWR from "swr";
import ApiService, { defaultSWROption } from "../api/api.service";
import { UserInfo } from "./auth.api.types";
import AuthEndpoints from "./auth.endpoint";

export const AuthService = {
  async logout(): Promise<void> {
    try {
      await ApiService.fetchData({
        url: AuthEndpoints.LOGOUT,
        method: "POST",
      });
      console.log("Logout successful");
    } catch (error) {
      console.error("Logout failed", error);
    }
  },

  getUserInfo(): {
    data: UserInfo | undefined;
    error: unknown;
    isLoading: boolean;
  } {
    const fetcher = () =>
      ApiService.fetchData<undefined, UserInfo>({
        url: AuthEndpoints.GET_USER_INFO,
        method: "GET",
      });

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, error, isLoading } = useSWR(
      AuthEndpoints.GET_USER_INFO,
      fetcher,
      defaultSWROption,
    );

    return {
      data: data?.data,
      error,
      isLoading,
    };
  },
};
